export default function dotLoader(blockName) {
	return (
		<div className={`dotLoader${ blockName ? ` ${ blockName }__progress` : '' }`}>
			<div className="bounce1"></div>
			<div className="bounce2"></div>
			<div className="bounce3"></div>
		</div>
	);
}
